import React from "react";

const PlusIcon = ({ className = ''}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="black" viewBox="0 0 22 21.99" className={className}>
        <polygon points="0.99 12.01 0 10.99 1 10.01 10.02 10.02 10.02 1 11.06 0 12.02 1 12.02 10.01 21 10.01 22 11.13 21 12.02 12.02 12.02 12.02 21 11.03 22 10.03 21 10.03 12.03 0.99 12.01"/>
    </svg>
);

export default PlusIcon;
